import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHttpClient } from "../shared/hooks/http-hook";
import { Button, Modal } from "react-bootstrap";

const PublicVideoPlayer = () => {
	const { videoId } = useParams();
	const { sendRequest } = useHttpClient();
	const [videoDetails, setVideoDetails] = useState(null);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		const fetchVideoDetails = async () => {
			if (videoId) {
				try {
					const response = await sendRequest(
						`/api/videos/${videoId}/public`,
						"GET",
						null,
						{}
					);
					setVideoDetails(response.data);
				} catch (err) {
					console.error("Error fetching video details:", err);
				}
			}
		};

		fetchVideoDetails();
	}, [videoId, sendRequest]);

	useEffect(() => {
		const script = document.createElement("script");
		script.src =
			"https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
		script.async = true;
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, []);

	useEffect(() => {
		if (showModal) {
			const script = document.createElement("script");
			script.src =
				"https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
			script.async = true;
			document.body.appendChild(script);

			return () => {
				document.body.removeChild(script);
			};
		}
	}, [showModal]);

	const handleOpenModal = () => setShowModal(true);
	const handleCloseModal = () => setShowModal(false);

	return (
		<div
			style={{
				minHeight: "100vh",
				backgroundColor: "#1c004b",
				margin: 0,
				padding: 0,
			}}
		>
			<div
				className="container"
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					padding: "20px 20px",
				}}
			>
				<a href="https://ratava.com">
					<img
						src="/logo-white.png"
						alt="logo"
						style={{
							width: "50%",
							padding: "20px 0",
						}}
					/>
				</a>
				<button
					style={{
						backgroundColor: "#ffffff",
						border: "none",
						color: "#1c004b",
						padding: "10px 20px",
						fontSize: "16px",
						cursor: "pointer",
						borderRadius: "4px",
					}}
					onClick={() => {
						window.location.href = "https://ratava.com/";
					}}
				>
					Learn More
				</button>
			</div>
			{videoDetails ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						color: "white",
						/*position: "relative",
						width: "80%",
						maxWidth: "900px",
						aspectRatio: "16/9",
						margin: "auto",*/
					}}
				>
					<video
						//width="auto"
						width="70%"
						height="auto"
						controls
						src={videoDetails.video_url}
					/>
					{videoDetails.followup && (
						<div style={{ textAlign: "center", marginTop: "1rem" }}>
							<Button
								style={{
									backgroundColor: "#ffffff",
									border: "none",
									color: "#1c004b",
									padding: "10px 20px",
									fontSize: "16px",
									cursor: "pointer",
									borderRadius: "4px",
								}}
								onClick={handleOpenModal}
								variant="primary"
							>
								Schedule a Meeting
							</Button>
						</div>
					)}
				</div>
			) : (
				<p style={{ color: "white" }}>Video not found</p>
			)}
			{videoDetails?.followup && (
				<Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
					<Modal.Header closeButton>
						<Modal.Title>Book a Meeting</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{/* The container that HubSpot transforms into the scheduling iframe */}
						<iframe
							title="calendly"
							src="https://calendly.com/maximus-ratava/15min"
							style={{ width: "100%", minWidth: "320px", height: "500px" }}
							frameborder="0"
						></iframe>
					</Modal.Body>
				</Modal>
			)}
		</div>
	);
};

export default PublicVideoPlayer;
